import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// components
import FormClient from "./FormClient";
import ModalBox from "../../ui/ModalBox";
import { Typography } from "@mui/material";

const AddClient = () => {
  const navigate = useNavigate();
  const [clientName, setClientName] = useState('x');
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <div>
      <Typography variant="Poster" component="h3" gutterBottom>
        Add Client
      </Typography>
      <div>
        <FormClient
          handleSuccess={handleSuccess}
          setClientName={setClientName}
        />
      </div>
      <ModalBox
        open={open}
        handleClose={handleClose}
        operation="add"
        text="The add operation has been completed successfully.. You added new client "
        name={clientName}
      />
    </div>
  );
};

export default React.memo(AddClient);